import React, { useState } from "react";
import { BookOpen } from "lucide-react";
import FullHeaderComponent from "./components/FullHeaderComponent";
import EmployeeHandbookContents from "./components/EmployeeHandbookContents";

const EmployeeHandbook = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (params) => {
    setSearchTerm(params?.keyword || "");
  };

  return (
    <div className="flex flex-col -mx-3 sm:-mx-4 md:-mx-6 -mt-3 sm:-mt-4 md:-mt-6">
      <FullHeaderComponent
        icon={BookOpen}
        title="Employee Handbook 2026"
        subtitle="Hyvid Global Edition · © 2025 Hyvid Pty Ltd"
        placeholder = "Search handbook..."
        searchHandler={handleSearch}
      />
      <div>
        <EmployeeHandbookContents searchTerm={searchTerm}/>
      </div>
    </div>
  );
};

export default EmployeeHandbook;